import { useEffect, useState } from 'react'
import { portalResolveService } from 'src/api/collection'
import { getPortal } from 'src/utils/portal-links'

// One lookup per workspace key per page load.
const requests = {}

const resolvePortal = shopKey => {
  if (!requests[shopKey]) {
    requests[shopKey] = portalResolveService(shopKey)
      .then(response => response?.data || null)
      .catch(() => null)
  }
  return requests[shopKey]
}

/**
 * Where a workspace's portal links point (see getPortal): its custom domain
 * once known, else the share host.
 */
const usePortal = shopKey => {
  const [resolved, setResolved] = useState(null)

  useEffect(() => {
    if (!shopKey) return undefined
    let cancelled = false
    resolvePortal(shopKey).then(result => {
      if (!cancelled) setResolved(result)
    })
    return () => {
      cancelled = true
    }
  }, [shopKey])

  // Path/course links don't need the workspace key (share…/portal/paths/{id}),
  // so this works before it is known; only `home` needs it.
  return getPortal({ shopKey, domain: shopKey ? resolved?.domain : null })
}

export default usePortal
